import * as React from 'react';
import { isEqual } from 'lodash';
import { Route } from '@reverbdotcom/commons/dist/route_settings';

import { MParticlePageName } from '@reverbdotcom/commons/dist/elog/mparticle_tracker';

import { CollectionHeaderActions, CollectionHeaderStore } from '../components/discovery/stores/collection_header_store';
import connectRouterChange from '../components/shared/connect_router_change';
import { SALE_ROUTE_PATH } from '../components/shared/constants';

function onLoad(props) {
  const { params } = props;
  const storeParams = CollectionHeaderStore.getState().params;

  if (isEqual(params, storeParams)) { return; }

  CollectionHeaderActions.fetchOrClear(params);
}

const SaleRoute = (
  <Route
    key={SALE_ROUTE_PATH}
    path={SALE_ROUTE_PATH}
    props={{
      clientSide: true,
      pageViewEvent: ({ params }) => ({
        pageName: MParticlePageName.Sale,
        curatedSetSlug: params.curated_set_slug,
      }),
    }}
    getComponent={(_location, cb) => {
      require.ensure(
        [],
        (require) => {
          const SaleGrid = require('../components/discovery/sales/sale_grid').default;
          const connected = connectRouterChange(onLoad)(SaleGrid, 'SaleGrid');
          cb(null, connected);
        },
        'marketplace',
      );
    }}
  />
);

export default SaleRoute;
